export default __webpack_public_path__ + "static/media/storageUnit1-afterC-2048w.d7f4167d.png";